<template>
	<el-card v-loading="isShowLoading">
		<div slot="header" class="u-flex u-row-between">
			<span class="u-font-weight-bold u-font-18">开具发票</span>
			<el-button v-if="!isEdit && isShowInvoiceContent" icon="el-icon-refresh" plain type="primary" @click="onReTry">
				更新发票
			</el-button>
		</div>
		<el-alert v-if="getInvoiceHint" :closable="false" class="u-m-b-15" show-icon type="warning">
			<template slot="title">
				<div class="u-flex-col">
					<span v-html="getInvoiceHint"></span>
				</div>
			</template>
		</el-alert>
		<div v-if="!isShowInvoiceContent" class="u-flex-col u-col-center">
			<el-button
				v-if="isShowInvoiceError"
				class="u-m-b-20 u-m-t-20"
				icon="el-icon-refresh"
				type="primary"
				@click="onReTry">
				重试
			</el-button>
			<el-empty v-else :description="getDesc" :image-size="80" class="u-font-18 u-font-weight-bold"></el-empty>
		</div>
		<avue-form v-else ref="refInvoiceFrom" v-model="formInvoice" :option="optionInvoice" @submit="onDealResult">
			<span slot="money">{{ totalPremium }}元</span>
			<!--      <span slot="title">{{ formInvoice.title }}</span>-->
			<template #menuForm="{}">
				<el-button v-if="!isInvoiceSubmit" icon="el-icon-edit" @click="onDealResult">修改</el-button>
			</template>

			<template slot="example1">
				<div class="u-flex-col u-font-weight-bold">
					<div>
						<el-image
							v-for="(itemData, index) in formInvoice.example1"
							:key="index"
							:preview-src-list="[itemData]"
							:src="itemData"
							class="u-m-l-20"
							style="width: 150px; height: 150px"></el-image>
					</div>
					<span>
						请从百度查询各省税务系统进入，或打开：
						<el-link href="http://www.800000361.com/gs/" target="_blank" type="primary">
							http://www.800000361.com/gs/
						</el-link>
						，选择企业对应地区进入。
					</span>
				</div>
			</template>
		</avue-form>
	</el-card>
</template>

<script>
import {changeReason} from '@/const/crud/invoice/invoiceStatus'
import store from '@/store'
import {getAddressMyList} from '@/views/insuranceCenter/api/productNew'
import {getLastInvoice} from 'meibao-insure/src/api/productCenterNew'
import {getBaseInvoiceOption, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {convertAreaCode, dealClearCode} from 'meibao-insure/src/util/commonUtils'
import {
	isAnZeProduct,
	isFgk,
	isFgkTuanYi,
	isGuoShouCai,
	isLibaoGuzhu,
	isMeiYa,
	isPingAnGuangFu,
	isRenBao,
	isXsmDadi,
	isXsmJianzhu,
	isXsmYangguang,
	isXsmZhiZao,
} from 'meibao-insure/src/util/productUtil'
import {mapGetters} from 'vuex'

export default {
	name: 'FormInvoiceNew',
	props: {
		insureType: {
			type: String | Number,
			default: -1,
		},
		productId: {
			type: Number | String,
			required: true,
		},
		sourceProductId: {
			type: Number | String,
			required: true,
		},
		totalPremium: {
			type: String | Number,
			required: true,
			default: 0,
		},
		isAdd: Boolean,
		isEdit: Boolean,
		isMore: Boolean,
	},
	computed: {
		...mapGetters(['userInfo', 'permissions']),
		isInvoiceSubmit: {
			get() {
				return this.optionInvoice.submitBtn
			},
			set(value) {
				this.optionInvoice.submitBtn = value
			},
		},
		isHasMail() {
			let columns = this.optionInvoice.column || []
			if (columns.length <= 0) {
				return false
			}
			// 判断是否包含邮寄地址
			let tempIndex = columns.findIndex(({prop}) => prop === 'mailName' || prop === 'mailPhone')
			return tempIndex >= 0
		},
		getDesc() {
			return `确认投保${isRenBao(this.insureType) ? '人' : '企业'}后，才能填写发票数据！`
		},
		//发票提醒
		getInvoiceHint() {
			// 发票类型
			let {invoiceType} = this.formInvoice
			if (invoiceType === '2') {
				return '增值税电子普通发票的法律效力、基本用途、基本使用规定等与税务局监制的增值税普通发票相同。'
			}

			/**
			 * 1、太保雇主、太保团意：电子专票开具时效为从申请日起5-10个工作日
			 * 2、利宝雇主：电子专票开具时效为从申请日起5-10个工作日
			 * 3、美亚团意：电子专票开具时效为从申请日起7-14个工作日
			 * 4、平安光伏团意：电子专票开具时效为从申请日起5-7个工作日
			 * 5、泰康安责：电子专票开具时效为从申请日起5-7个工作日
			 * 6、广东太保灵活用工保：电子专票开具时效为从申请日起1-3个工作日
			 * 7、国寿团意（扫码需提供代刷卡盖章件）、阳光制造业雇主、阳光物流雇主：纸质专票开具邮寄时效为从申请日起20个工作日左右
			 */
			let hintTime = ''
			if (isFgk(this.insureType) || isFgkTuanYi(this.insureType) || isLibaoGuzhu(this.insureType)) {
				hintTime = '电子专票开具时效为从申请日起|5-10|个工作日。'
			} else if (isMeiYa(this.insureType)) {
				hintTime = '电子专票开具时效为从申请日起|7-14|个工作日。'
			} else if (isPingAnGuangFu(this.insureType) || isAnZeProduct(this.insureType)) {
				hintTime = '电子专票开具时效为从申请日起|5-7|个工作日。'
			} else if (isXsmJianzhu(this.insureType) || isXsmZhiZao(this.insureType)) {
				hintTime = '电子专票开具时效为从申请日起|1-3|个工作日。'
			} else if (isGuoShouCai(this.insureType) || isXsmYangguang(this.insureType)) {
				hintTime = '纸质专票开具邮寄时效为从申请日起|20|个工作日左右。'
			}
			if (hintTime) {
				let [one, two, three] = hintTime.split('|')
				return `<div>${one}<span class="red-bold"> ${two} </span>${three}</div>`
			}
			return ''
		},
	},
	data() {
		return {
			isShowLoading: false,
			optionInvoice: {
				submitBtn: true,
				column: [],
			},
			//请求获取的产品中心数据
			invoiceAllData: null,
			lastUnitFormData: {},
			isShowInvoiceContent: false,
			isShowInvoiceError: false,
			formInvoice: {
				invoiceType: '',
				money: 0,
				identification: '',
				title: '',
				address: '',
				phone: '',
				bankName: '',
				bankNo: '',
				mailName: '',
				mailPhone: '',
				mailAreaCode: [],
				mailAddress: '',
				taxCertificate: '',
				example1: [require('@/../public/images/tax_ex1.png'), require('@/../public/images/tax_ex2.png')],
			},
			invoiceList: [],
		}
	},
	watch: {
		'formInvoice.invoiceType': {
			handler(newVal = '', oldVal = '') {
				//处理切换数据
				if (this.isShowInvoiceContent && newVal) {
					//切换显隐
					this.onChangeInvoiceType(newVal)
					//切换数据
					this.onInvoiceTypeChange(newVal)
				}
			},
			immediate: true,
		},
	},
	mounted() {
		this.$Bus.$on('taxTypeNew', this.onDealTaxType)
	},
	activated() {
		this.$Bus.$on('taxTypeNew', this.onDealTaxType)
	},
	deactivated() {
		this.$Bus.$off('taxTypeNew')
	},
	methods: {
		onDealResult(formData, done) {
			//处理是否可以输入
			if (this.isInvoiceSubmit) {
				let {invoiceType, $mailAreaCode = '', $invoiceType = ''} = this.formInvoice
				if (this.totalPremium <= 0) {
					this.$alert('开票金额必须大于0', '提示')
					done()
					return
				}
				//处理地址
				if (invoiceType === '1' && $mailAreaCode !== '') {
					//拼接汉字
					let [one, two, three] = $mailAreaCode.split('|')
					this.formInvoice.province = one.trim()
					this.formInvoice.city = two.trim()
					this.formInvoice.district = three.trim()
				}
				//对公国寿财加提醒
				// 非对公支付开具增值税专票，须补充单位授权支付委托书并单位盖章。对公支付无需提供，请确认是否开具增值税专票
				if (isGuoShouCai(this.insureType) && invoiceType === '1') {
					this.$confirm(
						'<div>当前开票类型：<span style="color:red; font-weight:bold">增值税专票</span>。</div><div>非对公支付开具增值税专票，需要补充<span style="color:red; font-weight:bold">单位授权支付委托书并单位盖章</span>。对公支付无需提供，请确认是否开具增值税专票?</div>',
						'提示',
						{
							confirmButtonText: '确定选择专票',
							cancelButtonText: '取消',
							dangerouslyUseHTMLString: true,
							type: 'warning',
						},
					)
						.then(() => {
							//确定后，处理其他情况
							this.onDealSpecialInvoice()
						})
						.catch(() => {})
						.finally(() => {
							done()
						})
					return
				}
				//处理其他情况
				this.onDealSpecialInvoice()
				done()
			} else {
				this.isInvoiceSubmit = true
				this.onLockForm(false)
			}
		},

		/**
		 * 处理发票逻辑
		 */
		onDealSpecialInvoice() {
			if (!this.isEdit) {
				this.$message.success('发票数据确认成功！')
				this.isInvoiceSubmit = false
				this.onLockForm(true)
				console.log(this.onGetSubInvoiceData(), '----')
			} else {
				this.$emit('onSubmittedData', this.onGetSubInvoiceData())
			}
		},

		onLockForm(disabled) {
			if (this.isMore) {
				return
			}
			this.optionInvoice.column.forEach((itemData) => {
				let {isSelfInput = false} = itemData
				itemData.disabled = disabled ? disabled : isSelfInput
			})
		},
		async onInvoiceTypeChange(val) {
			let {mailName = '', mailPhone = '', mailAddress = ''} = this.formInvoice
			//新需求：如果没有填写邮寄地址，则自动填充，填充了则不处理
			//如果新市民则返回
			if (val !== '1' || !this.isHasMail || this.envConfig.isBxXsm() || mailName || mailPhone || mailAddress) {
				console.error(
					'--------- 邮寄地址不请求！！！！',
					this.envConfig.isBxXsm(),
					mailName,
					mailPhone,
					mailAddress,
					val,
					this.isHasMail,
				)
				return
			}
			//发票新需求
			if (this.invoiceList.length <= 0) {
				//根据请求获取邮寄地址
				try {
					let myListResult = await getAddressMyList()
					let {code = -1, data = []} = myListResult.data || {}
					if (code === 0) {
						this.invoiceList = data
					}
				} catch (e) {
					//错误
					this.formInvoice.invoiceType = '2'
					this.$alert('获取专票地址失败，请联系管理员！', '提示', {
						confirmButtonText: '知道了',
					}).then(() => {})
					return
				}
			}
			//根据请求获取邮寄地址
			if (this.invoiceList.length > 0) {
				//说明存在地址信息！，自动填充，且不能修改
				this.onDealAddress(this.invoiceList[0])
			}
		},
		onGetSubInvoiceData() {
			//解构
			let {
				invoiceType = '',
				title = '',
				identification = '',
				mailAreaCode = [],
				province = '',
				city = '',
				district = '',
				bankNo = '',
			} = this.formInvoice
			let submitData = {
				invoiceType,
				inv_type: invoiceType,
				title,
				identification,
				identification_z: identification,
				identification_p: identification,
			}
			if (invoiceType === '1' && (bankNo || mailAreaCode.length > 0 || this.isEdit)) {
				Object.assign(submitData, this.formInvoice)
				if (mailAreaCode.length > 0) {
					submitData.mailAreaCode = mailAreaCode[2]
					submitData.mailAreaName = province + city + district
				} else {
					//如果没有邮寄地址，则不需要传递数据，删除
					this.$delete(submitData, 'mailAreaCode')
				}
			}
			//核保需要
			submitData.type = invoiceType
			submitData.money = parseInt((this.totalPremium * 100).toFixed(0))
			return submitData
		},
		getData() {
			return this.formInvoice
		},
		onSetInvoiceData(data = {}, unitData) {
			//设置数据
			let {mailAreaCode = '', invoiceType = '', type = ''} = data
			Object.assign(this.formInvoice, data, {invoiceType: `${invoiceType}`})
			if (!this.validatenull(mailAreaCode)) {
				this.formInvoice.mailAreaCode = convertAreaCode(mailAreaCode)
			}
			console.log('onSetInvoiceData------', unitData)
			//如果是批增，或者是发票管理 没有确定企业的，则现在就需要展示
			if (this.isAdd || this.isEdit || this.isMore) {
				let {unitName, unitCode} = unitData
				this.onDealTaxType({name: unitName, certNo: unitCode})
			}
		},

		/**
		 *  清除发票数据
		 */
		clearInvoiceData() {
			let {example1 = []} = this.formInvoice
			this.formInvoice = {example1, comeReason: ''}
			//判断存在，才清空
			if (this.$refs.refInvoiceFrom) {
				this.$refs.refInvoiceFrom.resetForm()
			}
		},

		//通过接口获取到专票地址处理
		onDealAddress(data = {}) {
			let {name = '', areaCodes = '', phoneNo = '', address = ''} = data
			this.formInvoice.mailName = name
			this.formInvoice.mailPhone = phoneNo
			this.formInvoice.mailAreaCode = areaCodes.split('|')
			this.formInvoice.mailAddress = address
			// //设置不可填写
			// this.optionInvoice.column.forEach((itemData) => {
			//   let {prop} = itemData
			//   if (this.isMailProp(prop)) {
			//     itemData.disabled = true
			//     itemData.isSelfInput = true
			//   }
			// })
		},
		// 报错重试
		onReTry() {
			if (this.validatenull(this.lastUnitFormData)) {
				this.$message.error('请重新确认企业信息！！')
				return
			}
			//非发票管理，重置数据
			if (!this.isEdit) {
				this.formInvoice.invoiceType = ''
			}
			this.onDealTaxType(this.lastUnitFormData, true)
		},
		//"taxType":1--一般纳税人，2--小规模    这么对应 专票 和 普票
		// 1就是普票  2就是专么
		async onDealTaxType(unitFormData, isMustQuest = false) {
			try {
				let {name = '', certNo = ''} = unitFormData
				if (!name) {
					//如果发票数据已经确认，则需要取消
					if (!this.isInvoiceSubmit) {
						this.isInvoiceSubmit = true
						this.onLockForm(false)
					}
					this.isShowInvoiceContent = false
					return
				}
				let {name: name1 = '1', certNo: certNo1 = '1'} = this.lastUnitFormData
				if (!isMustQuest && name1 === name && certNo1 === certNo) {
					this.isShowInvoiceContent = true
					return
				}
				this.isShowLoading = true
				//保存
				this.lastUnitFormData = unitFormData
				let resultInvoice = await getLastInvoice({
					applicant: unitFormData,
					orderInfo: {productId: this.productId, sourceProductId: this.sourceProductId},
				})
				let {code = -1, data = {}} = resultInvoice.data || {}
				if (code === 0 && data.invoiceType) {
					//赋值
					this.formInvoice.title = name
					this.formInvoice.identification = certNo
					this.invoiceAllData = data
					//处理发票展示数据
					Object.assign(this.optionInvoice, getCompleteOption(data, getBaseInvoiceOption(data)))
					//获取初步的发票数据 然后还要根据其他信息再次处理，
					//比如太保等专票和普票一致，
					//新市民特性：同保险公司，收件人，手机号等邮寄地址不必填，不同保险公司，都必填
					//新市民特性：新逻辑，如果是同一家公司，所有数据都不填写
					let isNeed = true
					if (this.envConfig.isBxXsm()) {
						//判断是否为同一个险种公司 投的自家险种
						let {clearcode = ''} = dealClearCode(this.insureType, store)
						console.log('onDealTaxType --newVal', clearcode)
						if (clearcode === '') {
							//为空，则是一家公司的，不必填
							isNeed = false
						}
					}
					this.optionInvoice.column.forEach((itemData) => {
						let {prop = ''} = itemData
						if (prop === 'identification' || prop === 'title') {
							itemData.disabled = true
							itemData.isSelfInput = true
							if (this.isMore) {
								itemData.display = false
							}
						} else {
							//新市民 如果是同一家公司，所有数据都不填写(不包含大地产品！)
							if (
								isNeed ||
								prop === 'money' ||
								prop === 'invoiceType' ||
								(isXsmDadi(this.insureType) && !this.isMailProp(prop))
							) {
								//新需求：编辑发票不需要默认值
								if (!this.isEdit) {
									//处理默认值
									let {defaultValue = ''} = this.invoiceAllData[prop] || {}
									if (defaultValue) {
										//需要特殊处理mailAreaCode
										if (prop === 'mailAreaCode' && typeof defaultValue === 'string') {
											defaultValue = convertAreaCode(defaultValue)
										}
										this.formInvoice[prop] = defaultValue
									}
								}
							} else {
								itemData.rules = []
								itemData.display = false
								//永远不显示
								itemData.isMustHide = true
							}
						}
					})
					//处理编辑
					this.onEditInvoiceTypeForce()

					this.isShowInvoiceContent = true
					this.isShowInvoiceError = false
					//重新初始化dic
					this.$nextTick(() => {
						if (this.$refs.refInvoiceFrom) {
							this.$refs.refInvoiceFrom.init()
						}
					})
				} else {
					this.isShowInvoiceError = true
				}
			} catch (e) {
				//出错了！！
				this.lastUnitFormData = {}
				this.isShowInvoiceContent = false
				this.isShowInvoiceError = true
				console.error(e.message)
			} finally {
				this.isShowLoading = false
			}
		},
		//切换发票处理数据
		onChangeInvoiceType(val) {
			let showValue = ''
			this.optionInvoice.column.forEach((itemData) => {
				let {prop = '', isMustHide = false} = itemData
				if (isMustHide) {
					return
				}
				let {visibleConditions = []} = this.invoiceAllData[prop] || {}
				if (visibleConditions.length > 0) {
					let {value = '-1'} = visibleConditions[0]
					showValue = value
					itemData.display = value === val
				} else if (prop === 'example1') {
					itemData.display = val === showValue
				}
			})
		},
		//是否确定
		isConfirm() {
			return this.optionInvoice.submitBtn
		},
		//是否为邮寄地址数据
		isMailProp(prop = '') {
			if (!prop) {
				return false
			}
			return ['mailName', 'mailPhone', 'mailAreaCode', 'mailAddress'].includes(prop)
		},
		//普票专票更改！！强制操作
		onEditInvoiceTypeForce() {
			//新需求：专票更改！强制操作
			//所有数据可填写，另外锁定开票类型，并且赋值
			if (this.isEdit) {
				this.optionInvoice.column.forEach((itemData) => {
					let {prop = ''} = itemData
					if (prop === 'invoiceType') {
						itemData.disabled = true
					}
				})
				//切换显隐
				this.onChangeInvoiceType(this.formInvoice.invoiceType)
				//加一些额外参数，，，，
				let [one, two] = changeReason()
				this.optionInvoice.column.unshift(one)
				this.optionInvoice.column.push(two)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}

::v-deep .el-card__body {
	padding: 20px 20px 0 20px;
}

//::v-deep .el-empty__description p {
//  color: #E6A23C;
//}
</style>
